<template>
  <div class="">
    <div class="relative">
      <input
        @keyup.enter="toSearch"
        type="text"
        v-model="searchInput"
        class="block w-full p-5 text-sm .placeholder-accent-gray-color::placeholder text-main-color border border-[#e6e6e6] rounded-sm bg-white"
        :placeholder="placeholder"
        required
      />

      <div
        @click="toSearch"
        class="absolute z-10 inset-y-0 end-0 p-5 cursor-pointer flex items-center"
      >
        <IconSearch></IconSearch>
      </div>
    </div>
  </div>
</template>

<script>
import IconSearch from '@icons/IconSearch.vue';

export default {
  name: 'SearchBar',
  props: {
    section: { type: String, default: 'publication' },
    placeholder: { type: String, default: '' },
  },
  components: { IconSearch },

  data() {
    return {
      loading: false,
      searchInput: '',
      routes: {
        mall: 'productSearch',
        food: 'foodSearch',
        publication: 'publicationSearch',
        news: 'newsSearch',
      },
      _clearHandler: null, // ✅
    };
  },

  methods: {
    toSearch() {
      const q = String(this.searchInput || '').trim();
      if (!q) return;

      this.$router.push({
        name: this.routes[this.section],
        query: { searchQuery: q },
      });
    },
  },

  mounted() {
    // ✅ сброс из clearFilter()
    this._clearHandler = () => {
      if (this.section === 'publication') {
        this.searchInput = '';
      }
    };
    window.addEventListener('publications:clear-search', this._clearHandler);
  },

  unmounted() {
    if (this._clearHandler) {
      window.removeEventListener('publications:clear-search', this._clearHandler);
    }
  },
};
</script>
